<template>
  <div class="wrapper">
    <Header></Header>
    <Content @changeModel="changeModel" />
    <About @changeModel="changeModel" />
    <Family />
    <Team @changeModel="changeModel" />
    <Recruit />

    <Footer />
    <Model
      :name="name"
      :isShow="isShow"
      @changeModel="changeModel"
      :desc2="desc2"
      :desc3="desc3"
      :desc1="desc1"
      :title="title"
    />
    <ReModel />
    <div class="modal" v-if="show">
      <div class="colse" @click="close">x</div>
    </div>
  </div>
</template>

<script>
import {
  Header,
  Content,
  About,
  Footer,
  Team,
  Family,
  Model,
  Recruit,
  ReModel,
} from "../components/index";
import { mapGetters } from "vuex";
export default {
  name: "Index",
  data() {
    return {
      isShow: false,
      name: "",
      desc1: "",
      desc2: "",
      desc3: "",
      title: "",
      show: true,
    };
  },
  computed: {
    ...mapGetters({
      language: "getType",
    }),
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener("keyup", (e) => {
        if (e.keyCode == 27) {
          this.closemodel();
        }
      });
    });
  },
  methods: {
    closemodel() {
      this.isShow = false;
    },
    close() {
      this.show = false;
    },
    changeModel(value, name, desc1, desc2, desc3, title) {
      this.isShow = value;
      this.name = name;
      this.desc1 = desc1;
      this.desc2 = desc2;
      this.desc3 = desc3;
      this.title = title;
    },
  },
  components: {
    Header,
    Content,
    About,
    Footer,
    Team,
    Family,
    Model,
    Recruit,
    ReModel,
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  min-width: 1200px;
  position: relative;
  .modal {
    width: 959px;
    height: 788px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.6);
    background: url("./images/1111_画板 1.png") no-repeat;
    background-size: 100% 100%;
    z-index: 100;
    box-shadow: rgba(0, 0, 0, 0.2) 0 0 10px 6px;

    .colse {
      position: absolute;
      cursor: pointer;
      width: 20px;
      height: 20%;
      right: 30px;
      top: 20px;
      font-size: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue